import { round, sanitizePrice } from 'utils/math'

export const integerToCents = (num: unknown): number => {
  return sanitizePrice(Number(num) * 100, true)
}

export const centsToInteger = (num: unknown): number => {
  return sanitizePrice(Number(num) / 100)
}

export const intToLetter = (num: number): string => {
  const index = (num - 1) % 26
  return String.fromCharCode(65 + index)
}

export const kilometersToMeters = (kilometers: number): number => {
  return Math.round(kilometers * 1000)
}

export const metersToKilometers = (distance: number): number => {
  return round(distance / 1000, 3)
}

export const secondsToMinutes = (seconds: number): number => {
  return round(seconds / 60, 0)
}

export const factorMultipliedBy100 = (factor: number): number => {
  return round(factor * 100, 0)
}

export const factorDividedBy100 = (factor: number): number => {
  return round(factor / 100, 2)
}
